import React, { useState, useRef } from "react";
import Dialog from "../../dialog/ImgDialog";
import {
  ArrowUpTrayIcon,
  PaperClipIcon,
  PlusIcon,
  XMarkIcon,
  CloudArrowUpIcon,
} from "@heroicons/react/24/outline";
import { InformationCircleIcon } from "@heroicons/react/24/solid";
import { BASE_URL } from "../../../customHooks/config";
import axios from "axios";
import { toast } from "react-toastify";
import { USER_DETAILS } from "../../layout/Layout";
import { useAtom, atom } from "jotai";
import Spinner from "../../layout/loader/Spinner";
export const USER_DETAILS_UPDATE_UPLOAD_DAILOG = atom({});

function UploadDialog({
  open,
  setOpen = () => {},
  handleClickOpen = () => {},
}) {
  const [prefill, setPrefill] = useState(false);
  const [loading, setLoading] = useState(false);
  const [userDetails] = useAtom(USER_DETAILS);
  const [userInfoUpdateDailog, setUserInfoUpdateDailog] = useAtom(
    USER_DETAILS_UPDATE_UPLOAD_DAILOG
  );

  const vendorId = userDetails?.data?.user_details?.vendor_details?.vendor_id;

  const handleClose = () => {
    setOpen(false);
  };

  const inputRef = useRef(null);
  const [file, setFile] = useState(null);

  const handleFile = (e) => {
    const res = e.target.files[0];
    setFile(res);
  };
  const handleRemoveFile = () => {
    setFile(null);
    setPrefill(false);
  };
  const handleUpload = () => {
    if (file) {
      setLoading(true);
      const formData = new FormData();
      formData.append("file", file);
      formData.append("vendor", vendorId);
      axios
        .post(`${BASE_URL}vendor/upload_agreement/`, formData, {
          withCredentials: true,
        })
        .then((res) => {
          if (res?.data?.success) {
            toast.success(res?.data?.data?.message);
            handleClose();
            setUserInfoUpdateDailog({ ...userInfoUpdateDailog, changed: true });
          } else {
            toast.error(res?.data?.data?.message);
          }
          setLoading(false);
        })
        .catch((err) => {
          toast.error(err?.data?.error);
          setLoading(false);
        });
    }
  };

  return (
    <div>
      <div>
        <Dialog
          visible={open}
          //   title={"Enter your amount"}
          handleCloseDialog={handleClose}
          // actionsPannel={DialogActions("bg-green")}
          size={"w-2/7"}
          color={"bg-green"}
        >
          <div className=" h-fit w-[500px]">
            <div>
              <div className="text-left flex flex-col items-stretch px-10  justify-start pt-6">
                <p className="text-lg font-semibold">Upload Document</p>

                <div>
                  <p className="text-sm text-[#6C757D] text-left leading-6 ">
                    You are just 1 step away. Kindly upload the Agreement
                    following the steps below:
                    <br />
                    Step 1:{" "}
                    <a
                      href="https://getwork-store-new.s3.ap-south-1.amazonaws.com/prod/Partner+agreement_Amended_17062024.docx"
                      className="text-[#2563EB] hover:underline"
                    >
                      {" "}
                      Download the Agreement{" "}
                    </a>{" "}
                    by clicking here. <br /> Step 2: Fill in the yellow-marked
                    fields, attach a stamp of INR 300, and sign the agreement
                    digitally. <br /> Step 3: Upload the Agreement.
                  </p>
                </div>
                <div className="h-fit mt-2 ">
                  <div className="flex items-center justify-center w-full mt-1 ">
                    <label
                      for="dropzone-file"
                      style={{ height: file ? "60px" : "230px" }}
                      className="flex flex-col items-center justify-center w-full  border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-[#f8fafc]  hover:bg-gray-100 "
                    >
                      <div
                        className="items-center  w-full "
                        style={{
                          display: "flex",
                          flexDirection: file ? "row" : "column",
                          justifyContent: file ? "space-between" : "center",
                          paddingLeft: "5%",
                          paddingRight: "5%",
                        }}
                      >
                        <div>
                          <input
                            ref={inputRef}
                            type="file"
                            onChange={handleFile}
                            className="hidden"
                            accept=".doc,.docx,.pdf"
                          />
                          <p className="text-xs text-[#6C757D]">
                            {file ? (
                              <p className="text-xs font-bold  text-black flex ">
                                <PaperClipIcon className="h-4 w-4 text-[#6C757D] mr-2 " />
                                {file?.name}
                              </p>
                            ) : (
                              <>
                                <div className="flex flex-col items-center mt-2 text-center ">
                                  <CloudArrowUpIcon className="w-8 h-8 mb-2 text-black " />

                                  {prefill
                                    ? "Last Uploaded"
                                    : "Accepts .pdf only"}
                                </div>
                              </>
                            )}
                          </p>
                        </div>
                        <div>
                          {!file && !prefill ? (
                            <button
                              onClick={() => {
                                inputRef.current.click();
                              }}
                              className="border border-[#2563EB] text-[#2563EB] mt-4 h-[35px] text-sm  rounded-md px-3 font-normal flex items-center "
                            >
                              Select file
                            </button>
                          ) : (
                            <button
                              onClick={handleRemoveFile}
                              className="bg-[#2563EB] rounded-full h-[30px] w-[30px] flex justify-center items-center "
                            >
                              <XMarkIcon className="h-4 w-4 text-white " />
                            </button>
                          )}
                        </div>
                      </div>
                    </label>
                    {/* <div className="border border-1 mt-3 bg-white border-[#CBD5E1] p-4 rounded-lg flex justify-between  items-center "> */}
                  </div>
                </div>

                <div className="flex flex-col mt-6 pb-8">
                  <button
                    className="bg-[#2563EB] text-white text-center h-[40px] text-sm  rounded-md px-3 font-normal flex justify-center items-center "
                    onClick={handleUpload}
                  >
                    {loading ? <Spinner /> : "Upload"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Dialog>
      </div>
    </div>
  );
}

export default UploadDialog;
